/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AttributeCreateRequest {
  active?: boolean;
  attributeGroupId?: number;
  attributeName?: string;
  attributeQuestion?: string;
  attributeTypeId?: number;
  mobileImage?: string;
  sensitiveContent?: boolean;
  syncToCustomerIO?: boolean;
  syncronizable?: boolean;
  webImage?: string;
}
